<template>
  <v-btn
      :icon="true"
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="error"
      @click="init()"
  >
    <v-icon>
      mdi-delete
    </v-icon>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Odstrániť užívateľa

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p>
            Pre odstránenie užívateľa je potrebné potvrdiť odstránenie.
          </p>

          <v-btn
              :rounded="true"
              :outlined="true"
              :loading="loading"
              :disabled="loading"
              color="error"
              @click="submit()"
          >
            <v-icon>
              mdi-delete
            </v-icon>

            Odstrániť
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Users from '@/services/users'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    data() {
      return {
        loading: false,
        dialog: false,
        User: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = false

        this.loading = true

        Users
          .read({
            id: this.id
          })
          .then((response) => {
            this.dialog = true

            this.User = response.data.data.User
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.dialog = true

            this.loading = false
          })
      },
      submit() {
        this.loading = true

        Users
          .delete({
            id: this.id
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
